<template>
  <v-card
    class="rounded ma-0 pa-0"
    style="border-radius: 38px !important; border: 6px solid black; background-color: rgb(245, 248, 253);"
    height="630"
  >
    <v-card-text class="ma-0 pa-0">
      <div
        style="border-top-right-radius: 32px;
            border-top-left-radius: 32px; overflow:hidden;"
      >
        <BusinessCardRotator
          :cardCorners="businessProfile.cardCorners"
          :logoFrame="businessProfile.logoFrame"
          :logoImageURL="businessProfile.logoImageURL"
          :reverseImageURL="businessProfile.reverseImageURL"
          :backgroundImageURL="businessProfile.backgroundImageURL"
          :showBackgroundElevation="false"
          :title="title"
          :subtitle="subtitle"
          :line1="line1"
          :line2="line2"
          :line3="line3"
          :animatedEntry="true"
          :qualification="qualification"
        />
      </div>
      <v-skeleton-loader v-bind="skeltonLoaderAttributes" type="list-item-avatar-two-line" light></v-skeleton-loader>
      <v-skeleton-loader
        v-bind="skeltonLoaderAttributes"
        type="list-item-three-line, actions"
        light
      ></v-skeleton-loader>
      <div class="iphone"></div>
    </v-card-text>
  </v-card>
</template>
<script>
import BusinessCardRotator from "@/components/BusinessCardRotator";
import { mapGetters } from "vuex";

export default {
  name: "BusinessCardOnDevice",
  components: {
    BusinessCardRotator,
  },
  data() {
    return {
      skeltonLoaderAttributes: {
        class: "my-3",
        boilerplate: true,
        elevation: 0,
      },
    };
  },
  computed: mapGetters(["businessProfile"]),
  props: {
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    line1: {
      type: String,
      default: "",
    },
    line2: {
      type: String,
      default: "",
    },
    line3: {
      type: String,
      default: "",
    },
    qualification: {
      type: String,
      default: "",
    },
  },
};
</script>
<style scoped>
.iphone:after {
  content: "";
  position: absolute;
  bottom: 6px;
  left: 50%;
  width: 100px;
  height: 3px;
  border-radius: 2px;
  -webkit-transform: translatex(-50%);
  transform: translatex(-50%);
  background-color: #000;
  z-index: 1000;
}
</style>
